<template>
    <v-row class="white-card" align="center" dense>
        <v-col cols="12">
            <kimsa-combobox outlined dense solo :items="typeOptions" @change="type = $event" :value="type"
                placeholder-class no-object />
        </v-col>
        <v-col cols="12">
            <v-simple-table class="table-weeks">
                <thead>
                    <tr>
                        <th v-for="(item, i) in headers" :key="i">
                            {{ item }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(week, weekIndex) in weeksData" :key="weekIndex">
                        <th>
                            {{ $t('days.week_short') }}{{ weekIndex + 1 }}
                        </th>
                        <td v-for="(value, valueIndex) in week" :key="valueIndex">
                            <div class="cell-value">
                                {{ value }}
                            </div>
                        </td>
                        <td>
                            <div class="cell-total-side">
                                {{ totalsPerWeek[weekIndex] }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('days.total_short') }}</th>
                        <td v-for="(total, dayIndex) in totalsPerDay" :key="dayIndex">
                            <div class="cell-total">
                                {{ total }}
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-col>
    </v-row>
</template>

<script>
import KimsaCombobox from '../common/inputs/KimsaCombobox.vue';

export default {
    components: { KimsaCombobox },
    name: "LastWeeksChart",
    props: {
        docs: {
            type: Array,
            default: () => [],
        },
    },
    data(vm) {
        return {
            typeOptions: [
                { name: vm.$t('statistics.wellness'), value: 'wellness' },
                { name: vm.$t('statistics.charge'), value: 'charge' },
                { name: vm.$t('statistics.sets_total'), value: 'sets_total' },
                { name: vm.$t('statistics.intensity_strength'), value: 'intensity_strength' },
            ],
            type: 'wellness',
            weeksData: [],
            totalsPerWeek: [],
            totalsPerDay: [],
            rpeTable: [
                { name: 10, reps: [100, 95, 91, 87, 85, 83, 81, 79] },
                { name: 9.5, reps: [97, 93, 89, 86, 84, 82, 80, 77.5] },
                { name: 9, reps: [95, 91, 87, 85, 83, 81, 79, 76] },
                { name: 8.5, reps: [93, 89, 86, 84, 82, 80, 77.5, 74.5] },
                { name: 8, reps: [91, 87, 85, 83, 81, 79, 76, 73] },
                { name: 7.5, reps: [89, 86, 84, 82, 80, 77.5, 74.5, 71.5] },
                { name: 7, reps: [87, 85, 83, 81, 79, 76, 73, 70] },
            ],
            rirTable: [
                { name: 0, reps: [100, 95, 91, 87, 85, 83, 81, 79] },
                { name: 1, reps: [95, 91, 87, 85, 83, 81, 79, 76] },
                { name: 2, reps: [91, 87, 85, 83, 81, 79, 76, 73] },
                { name: 3, reps: [89, 86, 84, 82, 80, 77.5, 74.5, 71.5] },
                { name: 4, reps: [87, 85, 83, 81, 79, 76, 73, 70] },
            ],
        }
    },
    computed: {
        headers(vm = this) {
            let days = ['']
            for (let i = 0; i < 7; i++) {
                days.push(`${vm.$t('days.day_short')}${i + 1}`)
            }
            days.push(vm.$t('days.total_short'))
            return days
        },

    },
    mounted() {
        const vm = this
        vm.getLastWeekValues()
    },
    methods: {
        async getLastWeekValues() {
            const vm = this;
            const endDate = vm.$moment().endOf('week');
            const startDate = vm.$moment(endDate).subtract(3, 'weeks').startOf('week');
            let currentDate = startDate.clone()
            let weeks = [[], [], [], []];
            let currentWeek = 0
            let dayCount = 0

            vm.totalsPerDay = Array(7).fill(0);
            let countPerDay = Array(7).fill(0);

            while (currentDate.isSameOrBefore(endDate)) {
                const currentRoutine = vm.docs.find(routine => routine.rawDate.full === currentDate.format('YYYY-MM-DD')) || null
                const value = Number(vm.getValueByType(currentRoutine));
                weeks[currentWeek].push(value !== 0 ? value : '');

                if (vm.type === 'intensity_strength') {
                    if (value !== 0) {
                        vm.totalsPerDay[dayCount] += value;
                        countPerDay[dayCount] += 1;
                    }
                } else {
                    vm.totalsPerDay[dayCount] += value;
                }

                currentDate.add(1, 'day');
                dayCount++;
                if (dayCount === 7) {
                    currentWeek++;
                    dayCount = 0;
                }
            }

            vm.weeksData = weeks
            vm.totalsPerWeek = weeks.map(week => {
                const total = week.reduce((acc, val) => acc + (val !== '' ? Number(val) : 0), 0);
                if (vm.type === 'intensity_strength') {
                    const validEntries = week.filter(val => val !== '');
                    const average = validEntries.length > 0 ? total / validEntries.length : 0;
                    return average !== 0 ? Number(average).toFixed(1).replace('.0', '') : '';
                }
                return total !== 0 ? Number(total).toFixed(1).replace('.0', '') : '';
            });


            if (vm.type === 'intensity_strength') {
                vm.totalsPerDay = vm.totalsPerDay.map((total, index) => {
                    return countPerDay[index] > 0 ? (total / countPerDay[index]).toFixed(1).replace('.0', '') : '';
                });
            } else {
                vm.totalsPerDay = vm.totalsPerDay.map(total => (total !== 0 ? total : ''));
            }
        },
        getValueByType(routine) {
            const vm = this;
            if (vm.type === 'wellness') {
                const preInfo = routine?.advance?.preInfo || null
                if (!preInfo) return ''
                return Number((preInfo.muscles_hurt + preInfo.sleep_night + preInfo.stressed + preInfo.tired) / 4).toFixed(0)
            }
            if (vm.type === 'charge') {
                const postInfo = routine?.advance?.postInfo || null
                if (!postInfo) return ''
                return postInfo.duration * postInfo.effort
            }
            if (vm.type === 'sets_total') {
                let sets_total = 0
                routine?.blocks?.forEach(block => {
                    block.exercises.forEach(exercise => {
                        if (exercise.type !== 'rest') {
                            let sets = Number(exercise.config?.sets?.length || 0)
                            sets_total += sets
                        }
                    })
                })
                return sets_total === 0 ? '' : sets_total
            }
            if (vm.type === 'intensity_strength') {
                let percentage = 0
                let rpe = 0
                let rir = 0
                let quantity_strong = 0
                routine?.blocks?.forEach(block => {
                    block.exercises.forEach(exercise => {
                        if (exercise.type !== 'rest') {
                            exercise.config?.sets?.forEach((set, i) => {
                                if (exercise.categories?.[0] === vm.$t('objectives.strong')) {
                                    let valuePercentage = vm.takeValueFromSet(set, 'percentage')
                                    percentage += valuePercentage
                                    let valueRpe = vm.takeValueFromSet(set, 'rpe')
                                    rpe += valueRpe ? vm.getValueFromTable(valueRpe, set, 'rpeTable') : 0
                                    let valueRir = vm.takeValueFromSet(set, 'rir')
                                    rir += valueRir ? vm.getValueFromTable(valueRir, set, 'rirTable') : 0
                                    if (valuePercentage > 0 || valueRir > 0 || valueRpe > 0) quantity_strong++
                                }
                            })
                        }
                    })
                })
                let intensity_strength = percentage + rpe + rir
                if (quantity_strong > 0) intensity_strength /= quantity_strong
                return intensity_strength === 0 ? '' : Number(intensity_strength).toFixed(1).replace('.0', '')
            }
            return ''
        },
        takeValueFromSet(set, attribute) {
            const vm = this
            let defaultValue = 0
            let value = set.data.find(data => data.name === vm.$t(`exercises.${attribute}`))
            return !!value || value === 0 ? Number(value.value || 0) : defaultValue
        },
        getValueFromTable(value, set, typeTable) {
            const vm = this
            if (typeTable === 'rpeTable') {
                if (value > 10) value = 10
                if (value < 7) value = 7
            }
            if (typeTable === 'rirTable') {
                if (value > 4) value = 4
                if (value < 0) value = 0
            }
            let findValueTable = vm[typeTable]?.find(table => table.name == value) || null
            let reps = set.data.find(data => data.name === vm.$t('exercises.reps')) || null
            let repsValue = reps && (Number(reps.value || 0) - 1) || 0
            if (repsValue > 7) repsValue = 7
            if (repsValue < 0) repsValue = 0
            return findValueTable && repsValue && findValueTable.reps[repsValue] || 0
        },
    },
    watch: {
        type() {
            this.getLastWeekValues()
        },
        docs() {
            this.getLastWeekValues()
        },
    }
}
</script>

<style scoped>
.table-weeks th {
    font-weight: bold !important;
    color: #000000 !important;
    font-size: 12px !important;
    padding: 0 !important;
    text-align: center !important;
    border-bottom: none !important;
    height: 0 !important;
}

.table-weeks td {
    padding: 0 !important;
    text-align: center !important;
    font-size: 12px !important;
    color: #FFFFFF;
    border-bottom: none !important;
    height: 0 !important;
}

.cell-value {
    background: #8BC34A;
    margin: 1px;
    padding: 4px 0;
    height: 23.7px;
    min-width: 23.7px;
}

.cell-total {
    background: #4CAF50;
    margin: 1px;
    padding: 4px 0;
    height: 23.7px;
    min-width: 23.7px;
}

.cell-total-side {
    background-color: #81D4FA;
    margin: 1px;
    padding: 4px 0;
    height: 23.7px;
    min-width: 23.7px;
}
</style>